exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .pc-order-history-header {\n  border-top: 1px solid #999999;\n  border-bottom: 1px solid #999999;\n  font-weight: bold;\n  font-family: \"JDSansPro-Medium\", \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-size: 16px;\n  padding: 15px 0;\n}\n\n", ""]);

// exports
